const NAV_SELECTOR = '[data-glide-el="controls[nav]"]'

export const SetActiveBulletInstantly = (
  Glide,
  Components,
  Events
) => {
  let controlNavs = []

  return {
    mount() {
      controlNavs = Array.from(
        Components.Html.root.querySelectorAll(NAV_SELECTOR)
      )

      Events.on('run', () => {
        const settings = Glide.settings
        const activeClass = settings.classes.nav.active

        controlNavs.forEach((controlNav) => {
          const activeItem = controlNav.children.item(
            Glide.index
          );

          controlNav.querySelectorAll(`.${activeClass}`).forEach((el) => {
            el.classList.remove(activeClass)
          })

          activeItem.classList.add(activeClass)
        })
      })
    },
  }
}
